import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Userprofile } from '../repositories/auth-repository'
import { TransactionStatus } from '@/constants/transactions'
import { NotificationStream } from '@/repositories/dashboard-repository'

export interface UserActionStatusData {
    message?: string
    title?: string
    status: TransactionStatus
    onDismiss?: () => void
}

interface AppState {
    userActionStatusData: UserActionStatusData | null
    userProfile: Userprofile
    authToken: string
    selectedStreamItem: NotificationStream | null
}

const initialState: AppState = {
    userActionStatusData: null,
    userProfile: {} as Userprofile,
    authToken: '',
    selectedStreamItem: null,
}

export const appStateSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setUserActionStatusData: (state, action: PayloadAction<UserActionStatusData>) => {
            state.userActionStatusData = action.payload
        },
        clearUserActionStatusData: state => {
            state.userActionStatusData = null
        },
        setSelectedStreamItem: (state, action: PayloadAction<NotificationStream | null>) => {
            console.log('setSelectedStreamItem', action.payload)
            state.selectedStreamItem = action.payload
        },
    },
})

export const appStateActions = appStateSlice.actions
export type AppStateActions = typeof appStateSlice.actions
export default appStateSlice.reducer
